"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorChip = void 0;
var tslib_1 = require("tslib");
var ExcludeBaseIcon_1 = require("@tableau/icons/ExcludeBaseIcon");
var NotificationCheckIcon_1 = require("@tableau/icons/NotificationCheckIcon");
var NotificationInfoOutlineIcon_1 = require("@tableau/icons/NotificationInfoOutlineIcon");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var Chip_1 = require("./Chip");
var SuccessSvg = NotificationCheckIcon_1.NotificationCheckIcon({ size: 12 });
var InfoSvg = NotificationInfoOutlineIcon_1.NotificationInfoOutlineIcon({ size: 14 });
/* eslint-disable max-len */
var WarningSvg = React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14" },
    React.createElement("path", { fill: "currentColor", d: "M6.20631136,0.486631016 C6.57745685,-0.162210339 7.50532059,-0.162210339 7.78367971,0.486631016 L13.9075804,11.6096257 C14.1859395,12.258467 13.814794,13 13.072503,13 L0.917488052,13 C0.267983436,13 -0.195948433,12.258467 0.0824106882,11.6096257 L6.20631136,0.486631016 Z M6.39188411,3.73083779 L6.39188411,9.29233512 L7.78367971,9.29233512 L7.78367971,3.73083779 L6.39188411,3.73083779 Z M6.39188411,10.2192513 L6.39188411,11.1461676 L7.78367971,11.1461676 L7.78367971,10.2192513 L6.39188411,10.2192513 Z" })); // leaving this one here because the corresponding icon from the icons library has fixed colors
/* eslint-enable max-len */
var ErrorSvg = ExcludeBaseIcon_1.ExcludeBaseIcon({ size: 14 });
var ErrorChipCSSVariables = Object.freeze({
    '--chip-background-default': '#FEDED8',
    '--chip-background-disabled': 'transparent',
    '--chip-background-hover': '#FEB8AB',
    '--chip-background-press': '#FE8F7D',
    '--chip-content-default': '#BA0517',
    '--chip-content-disabled': '#C9C9C9',
    '--chip-content-hover': '#8E030F',
    '--chip-content-press': '#640103',
});
var ResourceMap = {
    success: { icon: SuccessSvg, iconWidth: 12, getPrefix: Localize_1.Messages.successToastPrefix },
    info: { icon: InfoSvg, iconWidth: 14, getPrefix: Localize_1.Messages.infoToastPrefix },
    warning: { icon: WarningSvg, iconWidth: 14, getPrefix: Localize_1.Messages.warningToastPrefix },
    error: { icon: ErrorSvg, iconWidth: 14, getPrefix: Localize_1.Messages.errorToastPrefix, chipCSSVariables: ErrorChipCSSVariables },
};
var iconSpacing = TypeStyle.style({
    $nest: {
        '& > :first-child': { marginRight: 4 },
    }
});
/** Takes in a resource, returns a react function component for that type of chip. */
var FeedbackChipFactory = function (resource) {
    var feedbackChipStyleName = TypeStyle.style(tslib_1.__assign({}, resource.chipCSSVariables));
    var FeedbackChip = React.forwardRef(function (props, ref) {
        var children = props.children, message = props.message, chipProps = tslib_1.__rest(props, ["children", "message"]);
        var ariaLabel = "" + resource.getPrefix() + message;
        return React.createElement(Chip_1.Chip, tslib_1.__assign({ ref: ref, tooltip: message }, chipProps, { "aria-label": ariaLabel, className: TypeStyle.classes(props.className, feedbackChipStyleName, iconSpacing) }),
            resource.icon,
            children);
    });
    FeedbackChip.displayName = 'FeedbackChip';
    return FeedbackChip;
};
// export const SuccessChip = FeedbackChipFactory(ResourceMap.success);
// SuccessChip.displayName = 'SuccessChip';
// export const InfoChip = FeedbackChipFactory(ResourceMap.info);
// InfoChip.displayName = 'InfoChip';
// export const WarningChip = FeedbackChipFactory(ResourceMap.warning);
// WarningChip.displayName = 'WarningChip';
exports.ErrorChip = FeedbackChipFactory(ResourceMap.error);
exports.ErrorChip.displayName = 'ErrorChip';
//# sourceMappingURL=FeedbackChips.js.map